import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../components/axiosComp";
import "../../styles/sa-admin.css";
import logo from "../../assets/logo.svg";

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const force = new URLSearchParams(search).get("force") === "1";

const [form, setForm] = useState({
  email: "",
  password: "",
});
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // If already logged in (unless ?force=1), send to correct dashboard
    if (!force && localStorage.getItem("sa_jwt")) {
      try {
        const ctx = JSON.parse(localStorage.getItem("va_ctx") || "{}");

        if (ctx.role === "venue_admin") {
          navigate("/venue-admin/dashboard", { replace: true });
        } else {
          // superadmin OR country_admin → same dashboard area
          navigate("/super-admin/dashboard", { replace: true });
        }
      } catch {
        navigate("/super-admin/dashboard", { replace: true });
      }
    }
  }, [navigate, force]);


  const onChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.password) {
      toast.error("Email and password are required");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/api/auth/staff/login", {
        email: form.email.trim(),
        password: form.password,
      });

      if (!data?.token) throw new Error("Token missing in response");
      const user = data.user || {};

      // 🚫 This page is ONLY for superadmin
      if (user.role !== "superadmin") {
        toast.error(
          "This login page is only for Super Admin. Please use the correct login URL for your role."
        );
        setLoading(false);
        return;
      }

      // Store JWT
      localStorage.setItem("sa_jwt", data.token);

      // Store context for routing / scoping
      localStorage.setItem(
        "va_ctx",
        JSON.stringify({
          id: user._id,
          name: user.name,
          email: user.email,
          role: user.role,
          venues: user.venues || [],
          country: user.country || null,
        })
      );

      toast.success("Welcome back, Super Admin!");
      navigate("/super-admin/dashboard", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };


  return (
    <main className="sa-mantis">
      {/* soft blurred decoration (like Mantis) */}
      <div className="sa-blob" aria-hidden="true" />

      <header className="sa-topbar">
        <img src={logo} alt="OnGround" className="sa-brand" />
      </header>

      <section className="sa-wrap">
        <form className="sa-card" onSubmit={onSubmit} noValidate>
          <div className="sa-card-head">
            <h1>Sign in</h1>
          </div>

          <label className="sa-label" htmlFor="email">
            Email Address
          </label>
          <div className="sa-input">
            <input
              id="email"
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              placeholder="you@company.com"
              autoComplete="username"
              required
            />
          </div>

          <label className="sa-label" htmlFor="password">
            Password
          </label>
          <div className="sa-input">
            <input
              id="password"
              type={showPw ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={onChange}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="sa-eye"
              onClick={() => setShowPw((s) => !s)}
              aria-label={showPw ? "Hide password" : "Show password"}
              title={showPw ? "Hide password" : "Show password"}
            >
              {showPw ? "🙈" : "👁️"}
            </button>
          </div>
          <button className="sa-btn" type="submit" disabled={loading}>
            {loading ? "Signing in…" : "Login"}
          </button>

          <footer className="sa-legal">
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Terms and Conditions
            </Link>
            <span>•</span>
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Privacy Policy
            </Link>
          </footer>
        </form>
      </section>

      <footer className="sa-footnote">
        This site is protected by our{" "}
        <Link
          to="#"
          onClick={(e) => e.preventDefault()}
          className="sa-text-link"
        >
          Privacy Policy
        </Link>
        .
      </footer>
    </main>
  );
};

export default SuperAdminLogin;
